import { isNil } from 'lodash';
import { UtmParamKeys } from '~domain/model/url/url-parameters';

export class UrlParamHelper {
  /**
   * Add params (key,value) from the params Map to the baseURL as a search query
   * @param url may or may not  have protool (https) and hostname (test.com) in the url string
   * @param map of params (key,value)
   * @returns new URL
   */
  public appendParams(baseUrl: string, params: Map<string, string>): string {
    const url: URL = new URL(baseUrl);

    params.forEach((value: string, key: string) => {
      if (!isNil(value)) url.searchParams.append(key, value);
    });

    return url.toString();
  }

  /**
   * Add utm_source and utm_medium to URL and return new URL
   * @param url may or may not  have protool (https) and hostname (test.com) in the url string
   * @returns new URL
   */
  public appendUtmParams(url: string, source: string, medium: string, campaign?: string): string {
    const params: Map<string, string> = new Map([
      [UtmParamKeys.source, source],
      [UtmParamKeys.medium, medium],
      [UtmParamKeys.campaign, campaign],
    ]);

    return this.appendParams(url, params);
  }

  /**
   * Extract all params from url
   * @param url may or may not  have protool (https) and hostname (test.com) in the url string
   * @param params string params to extract from the url
   * @returns Map<paramName, paramValue>
   */
  public extractParams(url: string, params: string[]): Map<string, string> {
    const results: Map<string, string> = new Map<string, string>();

    params.forEach((param: string) => {
      const regex = new RegExp(`${param}=([^&]*)`);
      const result = regex.exec(url);
      if (result && result.length >= 2) {
        results.set(param, result[1]);
      }
    });

    return results;
  }
}
